export default __webpack_public_path__ + "static/media/config.2509a6f3.svg";